export default __webpack_public_path__ + "img/dIqJQFpf.0cfec0ba.svg";